import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ProjectAddonModel } from '../../models/project-addon.model';

export const ProjectAddonActions = createActionGroup({
  source: 'PROJECT_ADDON',
  events: {
    'Reset to Initial state': emptyProps(),

    'Load addon types': emptyProps(),
    'Load addon types success': props<{
      addonTypes: ProjectAddonModel.API.AddonTypeResponse[];
    }>(),
    'Load addon types fail': emptyProps(),

    'Load project plan addons': props<{
      projectId: string;
    }>(),
    'Load project plan addons success': props<{
      addons: ProjectAddonModel.AddonDocument[];
    }>(),
    'Load project plan addons fail': emptyProps(),

    'Load project camera addons': props<{
      projectId: string;
    }>(),
    'Load project camera addons success': props<{
      addons: ProjectAddonModel.AddonDocument[];
    }>(),
    'Load project camera addons fail': emptyProps(),

    'Create project addon': props<{
      target: ProjectAddonModel.AddonTarget;
      projectId: string;
      locationId: string;
      addon: ProjectAddonModel.API.CreateAddonDto;
    }>(),
    'Create project addon success': props<{
      addon: ProjectAddonModel.AddonDocument;
    }>(),
    'Create project addon fail': props<{
      target: ProjectAddonModel.AddonTarget;
    }>(),

    'Update project addon': props<{
      target: ProjectAddonModel.AddonTarget;
      addonId: string;
      addon: Partial<ProjectAddonModel.API.CreateAddonDto>;
    }>(),
    'Update project addon success': props<{
      addon: ProjectAddonModel.AddonDocument;
    }>(),
    'Update project addon fail': props<{
      target: ProjectAddonModel.AddonTarget;
    }>(),

    'Bulk create camera addons': props<{
      projectId: string;
      addons: ProjectAddonModel.API.BulkCreateDto;
    }>(),
    'Bulk create camera addons success': props<{
      addons: ProjectAddonModel.AddonDocument[];
    }>(),
    'Bulk create camera addons fail': emptyProps(),

    'Bulk update camera addons': props<{
      projectId: string;
      addons: ProjectAddonModel.API.BulkUpdateDto;
    }>(),
    'Bulk update camera addons success': props<{
      addons: ProjectAddonModel.AddonDocument[];
    }>(),
    'Bulk update camera addons fail': emptyProps(),

    'Bulk update plan addons': props<{
      projectId: string;
      addons: ProjectAddonModel.API.BulkUpdateDto;
    }>(),
    'Bulk update plan addons success': props<{
      addons: ProjectAddonModel.AddonDocument[];
    }>(),
    'Bulk update plan addons fail': emptyProps(),

    'Bulk delete camera addons': props<{
      projectId: string;
      addonIds: string[];
    }>(),

    'Bulk delete camera addons success': props<{
      addonIds: string[];
    }>(),
    'Bulk delete camera addons fail': emptyProps(),

    'Bulk delete plan addons': props<{
      projectId: string;
      addonIds: string[];
    }>(),
    'Bulk delete plan addons success': props<{
      addonIds: string[];
    }>(),
    'Bulk delete plan addons fail': emptyProps(),
  },
});
